import { ReactNode } from "react";
import { protectedResources } from "../authConfig";
import ManageLab from "../pages/labs/Lab_Manage";
import ManageOperator from "../pages/operator/Operator_Manage";
import ManagePipet from "../pages/pipet/Pipet_Manage";
import { LabContext, OperatorContext, PipetContext } from "./PvsContextProvider";
import { StreckDropDown } from "./StreckDropDown"
import { LabComboBox } from "./LabComboBox";

export enum StreckDropDownTypes {
    Lab,
    Pipet,
    Operator
}

interface TypedStreckDropDownProps {
    streckDropDownType: StreckDropDownTypes,
    selectedId?: number,
    selectedObject?: any,
    required: boolean,
    labId?: number, //Handles auto filling lab drop downs and filtering by lab id
    handleChange: ((id: number) => void),
    disabled?: boolean
    children?: ReactNode
}

export const TypedStreckDropDown = (props: TypedStreckDropDownProps) => {
    if (props.streckDropDownType === StreckDropDownTypes.Lab) {
        return <LabComboBox
            context={LabContext}
            title=' Lab'
            verb='GET'
            endpoint={protectedResources.apiLab.endpoint + 'GetAllLabs'}
            handleChange={props.handleChange}
            selectedId={props.selectedId}
            required={props.required}
            disabled={props.disabled}
            addObjectElement={<ManageLab isPopup={true} hideTabs={true}></ManageLab>}
        />;
    } else if (props.streckDropDownType === StreckDropDownTypes.Pipet) {
        return <StreckDropDown
            context={PipetContext}
            title=' Pipet'
            textField='serialNumber'
            verb='GET'
            endpoint={protectedResources.apiPipet.endpoint + 'GetActivePipets'}
            handleChange={props.handleChange}
            labId={props.labId}
            selectedId={props.selectedId}
            selectedObject={props.selectedObject}
            required={props.required}
            disabled={props.disabled}
            addObjectElement={<ManagePipet isPopup={true} labId={props.labId} ></ManagePipet>}
        />;
    } else if (props.streckDropDownType === StreckDropDownTypes.Operator) {
        return <StreckDropDown
            context={OperatorContext}
            title='n Operator'
            textField='operatorName'
            verb='GET'
            endpoint={protectedResources.apiOperator.endpoint + 'GetActiveOperators'}
            handleChange={props.handleChange}
            labId={props.labId}
            selectedId={props.selectedId}
            selectedObject={props.selectedObject}
            required={props.required}
            disabled={props.disabled}
            addObjectElement={<ManageOperator isPopup={true} labId={props.labId}></ManageOperator>}
        />;
    }

    return <>Not a valid type</>;
}